import { IxKeyValue, safeNav1 } from 'ix-ng-core';
import { Maybe } from 'ix-ng-static-utils';

export enum IxExceptionMessageEnvironment {
  client = 'client',
  server = 'server',
}

export class IxExceptionMessageEnvironmentDescription implements IxKeyValue<string, string> {
  static client: IxExceptionMessageEnvironmentDescription =
    new IxExceptionMessageEnvironmentDescription(
      'client',
      IxExceptionMessageEnvironment.client.toString(),
    );
  static server: IxExceptionMessageEnvironmentDescription =
    new IxExceptionMessageEnvironmentDescription(
      'server',
      IxExceptionMessageEnvironment.server.toString(),
    );

  key: string;
  value: string;

  [key: string]: string;

  private constructor(key: string, value: string) {
    this.key = key;
    this.value = value;
  }
}

const exceptionMessageEnvironment = IxExceptionMessageEnvironmentDescription;

export function IxExceptionMessageEnvironmentText(eme: Maybe<IxExceptionMessageEnvironment>) {
  return eme ? safeNav1(exceptionMessageEnvironment[eme], (x) => x.value) : null;
}
